import { ChangeEvent, ReactNode } from 'react'
import s from './style.module.scss'
import { Checkbox } from '@/components/ui'

interface ISelectAnswerProps {
  name: string
  children: ReactNode
  type?: 'checkbox' | 'radio'
  checked?: boolean
  value?: any
  onChange?: (event: ChangeEvent<any>) => void
  view?: 'quiz'
  register?: any
  rules?: any
}

const SelectAnswer = ({
  children,
  name,
  type = 'checkbox',
  checked,
  value,
  onChange,
  view = 'quiz',
  register,
  rules
}: ISelectAnswerProps) => (
  <div className={s['select-answer']} onClick={onChange}>
    <Checkbox
      register={register}
      name={name}
      type={type}
      checked={checked}
      value={value}
      onChange={onChange}
      view={view}
      rules={rules}
    />
    {children}
  </div>
)

export default SelectAnswer
